import React, { useRef, useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInstagram, faFacebook, faYoutube, faWhatsapp, faTiktok } from "@fortawesome/free-brands-svg-icons";
import { faBars, faXmark } from "@fortawesome/free-solid-svg-icons";

// Social media links data
const socials = [
  {
    icon: faInstagram,
    url: "https://instagram.com/annyeongaisyasyalc",
  },
  {
    icon: faTiktok,
    url: "https://www.tiktok.com/@annyeongaisyasya",
  },
  {
    icon: faFacebook,
    url: "https://www.facebook.com/profile.php?id=61555662309762&mibextid=2JQ9oc",
  },
  {
    icon: faYoutube,
    url: "https://www.youtube.com/@AnnyeongAisyasya",
  },
  {
    icon: faWhatsapp,
    url: "https://wa.me/60145893016",
  },
];

const Header = () => {
  const headerRef = useRef(null);
  const lastScrollY = useRef(0);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
    // Prevent body scrolling when mobile menu is open
    if (!mobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
  };
  const handleScroll = useCallback(() => {
    const currentScrollY = window.scrollY;
    
    if (headerRef.current) {
      // Only hide/show header on desktop, like your old project
      if (!isMobile) {
        if (currentScrollY < lastScrollY.current || currentScrollY < 10) {
          headerRef.current.style.transform = "translateY(0)";
        } else {
          headerRef.current.style.transform = "translateY(-100%)";
        }
      } else {
        // Always keep header visible on mobile
        headerRef.current.style.transform = "translateY(0)";
      }
    }
    
    lastScrollY.current = currentScrollY;
  }, [isMobile]);  useEffect(() => {
    const handleResize = () => {
      const newIsMobile = window.innerWidth < 768;
      setIsMobile(newIsMobile);
      
      // Close mobile menu when switching from mobile to desktop
      if (!newIsMobile && mobileMenuOpen) {
        setMobileMenuOpen(false);
        document.body.style.overflow = 'unset';
      }
    };

    const handleClickOutside = (event) => {
      // Close mobile menu when clicking outside of it
      if (mobileMenuOpen && headerRef.current && !headerRef.current.contains(event.target)) {
        setMobileMenuOpen(false);
        document.body.style.overflow = 'unset';
      }
    };

    window.addEventListener('resize', handleResize);
    window.addEventListener("scroll", handleScroll);
    document.addEventListener('click', handleClickOutside);
    
    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener("scroll", handleScroll);
      document.removeEventListener('click', handleClickOutside);
      document.body.style.overflow = 'unset';
    };
  }, [handleScroll, mobileMenuOpen]);
  return (
    <header ref={headerRef} style={{ transition: "transform 0.3s ease" }}>
      <div className="header-content">
        {/* Logo */}
        <img
          src="/assets/logos/logo.jpg"
          alt="Annyeong Aisyasya Logo"
          className="logo"
        />

        {/* Desktop Navigation */}
        <div className="desktop-nav">
          {/* Desktop Navigation Menu (centered) */}
          <nav className="nav nav-center">
            <ul>
              <li><Link to="/" className="nav-item">Home</Link></li>
              <li><Link to="/about" className="nav-item">About Us</Link></li>
              <li><Link to="/courses" className="nav-item">Courses</Link></li>
              <li><Link to="/products" className="nav-item">Products</Link></li>
              <li><Link to="/faq" className="nav-item">FAQ</Link></li>
              <li><Link to="/contact" className="nav-item">Contact</Link></li>
            </ul>
          </nav>
          {/* Social Media Icons (right) */}
          <nav className="socials socials-right">
            {socials.map((social, index) => (
              <a
                key={index}
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                className={social.icon === faTiktok ? 'mobile-only' : ''}
              >
                <FontAwesomeIcon icon={social.icon} size="2x" style={{ color: "#5a2d24" }} />
              </a>
            ))}
          </nav>
        </div>
        {/* Mobile Menu Toggle Button (always at far right) */}
        <button className="mobile-menu-toggle header-burger-right" onClick={toggleMobileMenu} aria-label="Toggle mobile menu">
          <FontAwesomeIcon icon={mobileMenuOpen ? faXmark : faBars} size="lg" style={{ color: "#5a2d24" }} />
        </button>

        {/* Mobile Navigation Menu */}
        <div className={`mobile-menu ${mobileMenuOpen ? 'active' : ''}`}>
          <nav className="mobile-nav">
            <ul>
              <li><Link to="/" className="nav-item" onClick={toggleMobileMenu}>Home</Link></li>
              <li><Link to="/about" className="nav-item" onClick={toggleMobileMenu}>About Us</Link></li>
              <li><Link to="/courses" className="nav-item" onClick={toggleMobileMenu}>Courses</Link></li>
              <li><Link to="/products" className="nav-item" onClick={toggleMobileMenu}>Products</Link></li>
              <li><Link to="/faq" className="nav-item" onClick={toggleMobileMenu}>FAQ</Link></li>
              <li><Link to="/contact" className="nav-item" onClick={toggleMobileMenu}>Contact</Link></li>
            </ul>
          </nav>
          
          {/* Mobile Social Media Icons */}
          <nav className="mobile-socials">
            {socials.map((social, index) => (
              <a
                key={index}
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => {
                  // Close mobile menu when social link is clicked
                  setTimeout(() => {
                    setMobileMenuOpen(false);
                    document.body.style.overflow = 'unset';
                  }, 100);
                }}              >
                <FontAwesomeIcon icon={social.icon} size="lg" style={{ color: "#5a2d24" }} />
              </a>
            ))}
          </nav>
        </div>
        
        {/* Mobile Menu Overlay */}
        {mobileMenuOpen && (
          <div 
            className="mobile-menu-overlay" 
            onClick={toggleMobileMenu}
            aria-hidden="true"
          ></div>
        )}</div>
    </header>
  );
};

export default Header;